(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const input = document.getElementById('CollectionSearchInput');
    const clearBtn = document.getElementById('CollectionSearchClear');
    const filtersEl = document.getElementById('CollectionFilters');
    const emptyEl = document.getElementById('CollectionFiltersEmpty');

    let activeType = 'all';
    let activePrice = 'all';

    function activatePill(buttons, activeBtn) {
      buttons.forEach(function (b) {
        const isActive = b === activeBtn;
        b.classList.toggle('collection-filter-pill--active', isActive);
        b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    // Houd de filterstatus in de URL (?type=rood&prijs=lt15&zoek=...) zodat
    // refresh, terugknop en gedeelde links de filterkeuze bewaren.
    function syncUrl() {
      const params = new URLSearchParams(window.location.search);
      params.delete('type');
      params.delete('prijs');
      params.delete('zoek');
      if (activeType !== 'all') params.set('type', activeType);
      if (activePrice !== 'all') params.set('prijs', activePrice);
      const query = input ? input.value.trim() : '';
      if (query) params.set('zoek', query);
      const qs = params.toString();
      history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
    }

    function applyAllFilters() {
      const query = input ? input.value.toLowerCase().trim() : '';
      const items = document.querySelectorAll('.product-grid__item[data-product-id]');
      let visibleCount = 0;

      items.forEach(function (item) {
        const title = item.dataset.productTitle || '';
        const wijnmaker = item.dataset.productWijnmaker || '';
        const type = item.dataset.productType || '';
        const price = parseInt(item.dataset.productPrice || '0', 10);

        const searchMatch = !query || title.includes(query) || wijnmaker.includes(query);
        const typeMatch = activeType === 'all' || type === activeType;

        var priceMatch = true;
        if (activePrice === 'lt15') priceMatch = price < 1500;
        else if (activePrice === '15-20') priceMatch = price >= 1500 && price <= 2000;
        else if (activePrice === '20-25') priceMatch = price > 2000 && price <= 2500;
        else if (activePrice === 'gt25') priceMatch = price > 2500;

        const visible = searchMatch && typeMatch && priceMatch;
        item.classList.toggle('product-grid__item--hidden', !visible);
        if (visible) visibleCount++;
      });

      if (clearBtn) clearBtn.hidden = !(input && input.value);
      if (emptyEl) emptyEl.hidden = visibleCount > 0;

      document.querySelectorAll('.facets-count-only [role="status"]').forEach(function (el) {
        el.textContent = visibleCount === 1 ? '1 product' : visibleCount + ' producten';
      });

      syncUrl();
    }

    if (input) {
      input.addEventListener('input', applyAllFilters);
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          input.value = '';
          applyAllFilters();
          input.focus();
        });
      }
    }

    const resetBtn = document.getElementById('CollectionFiltersReset');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        if (input) input.value = '';
        activeType = 'all';
        activePrice = 'all';
        if (filtersEl) {
          const typeBtns = Array.from(filtersEl.querySelectorAll('[data-filter-type]'));
          activatePill(typeBtns, typeBtns.find(function (b) { return b.dataset.filterType === 'all'; }));
          const priceBtns = Array.from(filtersEl.querySelectorAll('[data-filter-price]'));
          activatePill(priceBtns, priceBtns.find(function (b) { return b.dataset.filterPrice === 'all'; }));
        }
        applyAllFilters();
      });
    }

    if (filtersEl) {
      filtersEl.querySelectorAll('[data-filter-type]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          activeType = btn.dataset.filterType;
          activatePill(Array.from(filtersEl.querySelectorAll('[data-filter-type]')), btn);
          applyAllFilters();
        });
      });

      filtersEl.querySelectorAll('[data-filter-price]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          activePrice = btn.dataset.filterPrice;
          activatePill(Array.from(filtersEl.querySelectorAll('[data-filter-price]')), btn);
          applyAllFilters();
        });
      });
    }

    // Filterstatus uit de URL herstellen (deep links, refresh, terugknop)
    const initParams = new URLSearchParams(window.location.search);
    let initFromUrl = false;

    const urlType = initParams.get('type');
    if (urlType && filtersEl) {
      const typeBtns = Array.from(filtersEl.querySelectorAll('[data-filter-type]'));
      const typeMatch = typeBtns.find(function (b) { return b.dataset.filterType === urlType; });
      if (typeMatch) {
        activeType = urlType;
        activatePill(typeBtns, typeMatch);
        initFromUrl = true;
      }
    }

    const urlPrice = initParams.get('prijs');
    if (urlPrice && filtersEl) {
      const priceBtns = Array.from(filtersEl.querySelectorAll('[data-filter-price]'));
      const priceMatch = priceBtns.find(function (b) { return b.dataset.filterPrice === urlPrice; });
      if (priceMatch) {
        activePrice = urlPrice;
        activatePill(priceBtns, priceMatch);
        initFromUrl = true;
      }
    }

    const urlQuery = initParams.get('zoek');
    if (urlQuery && input) {
      input.value = urlQuery;
      initFromUrl = true;
    }

    if (initFromUrl) applyAllFilters();

    // Re-apply filters when infinite scroll appends new product items
    const resultsList = document.querySelector('results-list');
    if (resultsList) {
      const observer = new MutationObserver(function (mutations) {
        let hasNewItems = false;
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE &&
                (node.classList.contains('product-grid__item') ||
                 node.querySelector('.product-grid__item'))) {
              hasNewItems = true;
              break;
            }
          }
          if (hasNewItems) break;
        }
        if (hasNewItems) applyAllFilters();
      });
      observer.observe(resultsList, { childList: true, subtree: true });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
